/**
 * HUB-F — Carte réparation (DS Remobiles, consultation).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MagasinBadge from '../MagasinBadge';
import {
  formatRepairDate,
  statusBadgeClass,
} from '../../utils/reparations/reparationsDisplay';

export default function ActiviteReparationCard({ device, testIdPrefix = 'activite-reparations' }) {
  return (
    <article
      className="rounded-xl border p-4"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid={`${testIdPrefix}-card-${device.ref}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
        <div className="min-w-0 flex-1">
          <Link
            to={`/reparations/${device.ref}`}
            className="font-semibold text-[var(--rm-white)] hover:text-[var(--rm-red-light)] text-sm inline-flex items-center gap-1"
            data-testid={`${testIdPrefix}-link-${device.ref}`}
          >
            {device.ref}
            <ArrowRight className="w-3 h-3 shrink-0" />
          </Link>
          <p className="text-xs text-[var(--rm-gray-400)] mt-0.5 truncate">
            {device.model || '—'}
            {device.problem ? ` · ${device.problem}` : ''}
          </p>
        </div>
        <span className={statusBadgeClass(device.status)}>{device.status || '—'}</span>
      </div>

      <div className="flex flex-wrap items-center gap-2 mb-2">
        <MagasinBadge code={device.magasin_id || 'M1'} size="sm" />
        {device.technician_name && (
          <span className="text-xs text-[var(--rm-gray-500)]">{device.technician_name}</span>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
        <div className="min-w-0">
          <span className="text-[var(--rm-gray-500)]">Client </span>
          <span className="text-[var(--rm-gray-300)]">{device.client_name || '—'}</span>
        </div>
        <div>
          <span className="text-[var(--rm-gray-500)]">Mis à jour </span>
          <span className="text-[var(--rm-gray-300)]">{formatRepairDate(device.updated_at || device.created_at)}</span>
        </div>
      </div>
    </article>
  );
}
